//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InvalidFeedback from "@/components/common/input/InvalidFeedback";

export default {
  name: "contact",
  components: { InvalidFeedback },
  layout: "frontend/lp",
  data: () => ({
    formData: {
      company: "",
      name: "",
      email: "",
      phone: "",
      content: ""
    },
    btnLoading: false
  }),
  methods: {
    async submitForm() {
      this.$nuxt.$loading.start()
      this.btnLoading = true
      const responseData = await this.$frontendRepositories.contact.store(this.formData);
      if (!responseData.status) {
        this.btnLoading = false
        return this.$notify.error({ title: responseData.message });
      }
      this.btnLoading = false
      return this.$router.push('/contact-complete');
    }
  }
};
